// extracted by mini-css-extract-plugin
module.exports = {"container":"landing-feature-policy-pages_container__dBBnb","title":"landing-feature-policy-pages_title__zZYv_"};